import AssetsIcon from '@mui/icons-material/SpellcheckRounded'

import AssetsList from './AssetsList'

const resource = {
  list: AssetsList,
  icon: AssetsIcon
}

export default resource